<template>
  <div class="w-full h-full">
    <div class="flex justify-between items-center">
      <div class="title text-lg mb-10px cursor-pointer">
        <el-page-header
          v-if="formProps.pageType === 'read'"
          @back="$emit('cancel')"
          content="详情"
        ></el-page-header>
        <span
          v-if="formProps.pageType !== 'read'"
          class="border-l-3 border-color-primary pl-10px text-18px"
          >{{ formProps.pageType === 'create' ? '新增' : '编辑' }}</span
        >
      </div>
    </div>
    <div
      class="w-full overflow-y-auto overflow-x-hidden"
      :class="[formProps.pageType === 'read' ? 'detail-height' : 'custom-height']"
    >
      <el-form ref="form" label-width="150px" class="mr-20px" :rules="rules" :model="formData">
        <el-row :gutter="10">
          <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
            <el-form-item label="岗位名称" prop="postName">
              <el-input
                v-model="formData.postName"
                placeholder="请输入岗位名称"
                maxlength="50"
                show-word-limit
                clearable
                :disabled="formProps.pageType === 'read'"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
            <el-form-item label="编号" prop="postNum">
              <el-input
                v-model="formData.postNum"
                placeholder="请输入编号"
                maxlength="50"
                show-word-limit
                clearable
                :disabled="formProps.pageType === 'read'"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
            <el-form-item label="工作关联风险区域" prop="jobAssociatedRiskAreasIds">
              <el-select
                ref="areaSelect"
                v-model="formData.jobAssociatedRiskAreasIds"
                placeholder="请选择工作关联风险区域"
                class="w-full"
                clearable
                filterable
                multiple
                collapse-tags
                :disabled="formProps.pageType === 'read'"
                @change="areaChange"
              >
                <el-option
                  v-for="item in areaList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
            <el-form-item label="风险等级" prop="riskLevel">
              <el-select
                v-model="formData.riskLevel"
                placeholder="请选择风险等级"
                class="w-full"
                filterable
                clearable
                disabled
              >
                <el-option
                  v-for="item in resultList"
                  :key="item.code"
                  :label="item.displayName"
                  :value="Number(item.code)"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
            <el-form-item label="警示标志" prop="warningSignsIds">
              <el-select
                v-model="formData.warningSignsIds"
                placeholder="请选择警示标志"
                class="w-full"
                filterable
                clearable
                multiple
                :disabled="formProps.pageType === 'read'"
              >
                <el-option
                  v-for="item in markList"
                  :key="item.code"
                  :label="item.displayName"
                  :value="item.code"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
            <el-form-item label="主管单位" prop="competentUnit">
              <el-input
                v-model="formData.competentUnit"
                placeholder="请输入主管单位"
                maxlength="50"
                show-word-limit
                clearable
                :disabled="formProps.pageType === 'read'"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
            <el-form-item label="主要负责人" prop="principalChargePerson">
              <el-input
                v-model="formData.principalChargePerson"
                placeholder="请输入主要负责人"
                maxlength="50"
                show-word-limit
                clearable
                :disabled="formProps.pageType === 'read'"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
            <el-form-item label="现场负责人" prop="fieldManager">
              <el-input
                v-model="formData.fieldManager"
                placeholder="请输入现场负责人"
                maxlength="50"
                show-word-limit
                clearable
                :disabled="formProps.pageType === 'read'"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="图片" prop="warningSignPicture">
              <img-upload
                v-model="formData.warningSignPicture"
                :upload-width="120"
                :upload-height="120"
                :maxSize="20"
                :limit="5"
                :isDisabledUploadComponent="formProps.pageType === 'read'"
                :isShowDeleteButton="formProps.pageType !== 'read'"
              ></img-upload>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
            <el-form-item label="危险有害因素" prop="dangerousHarmfulFactors">
              <el-input
                v-model="formData.dangerousHarmfulFactors"
                placeholder="请输入危险有害因素,多个分号隔开"
                type="textarea"
                :rows="4"
                maxlength="3000"
                show-word-limit
                clearable
                :disabled="formProps.pageType === 'read'"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
            <el-form-item label="风险管控措施" prop="riskControlMeasures">
              <el-input
                v-model="formData.riskControlMeasures"
                placeholder="请输入风险管控措施,多个分号隔开"
                type="textarea"
                :rows="4"
                maxlength="3000"
                show-word-limit
                clearable
                :disabled="formProps.pageType === 'read'"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
            <el-form-item label="应急处置措施" prop="emergencyMeasures">
              <el-input
                v-model="formData.emergencyMeasures"
                placeholder="请输入应急处置措施"
                type="textarea"
                :rows="4"
                maxlength="3000"
                show-word-limit
                clearable
                :disabled="formProps.pageType === 'read'"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
            <el-form-item label="应急电话" prop="emergencyTelephone">
              <el-input
                v-model="formData.emergencyTelephone"
                placeholder="请输入应急电话,多个建议分号隔开"
                type="textarea"
                :rows="4"
                maxlength="3000"
                show-word-limit
                clearable
                :disabled="formProps.pageType === 'read'"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="附件" prop="annex">
              <form-upload
                v-model="formData.annex"
                :accept="['pdf', 'doc', 'docx', 'xls', 'xlsx']"
                :disabled="pageType === 'read'"
                :maxSize="50"
                :limit="999"
                uploadTipText="拖拽上传"
                :show-text="formProps.pageType === 'read'"
              ></form-upload>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div
      class="w-full flex justify-center items-center mt-5 mb-5"
      v-if="formProps.pageType !== 'read' && formProps.pageType !== 'refreshPublish'"
    >
      <el-button type="primary" size="small" @click="submitForm" :loading="loading">保存</el-button>
      <el-button @click="closeDialog" size="small">取消</el-button>
    </div>
  </div>
</template>

<script>
import { AreaApi } from '@wiz-api/area-management'
import utils from '@/components/safety/enumField/utils'
import { EmployeesHazardCharacteristicsCardApi } from '@wiz-api/double-prevention-management'
import ImgUpload from '@/components/safety/ImgUpload/ImgUpload'
import FormUpload from '@/components/safety/FileUpload/FormUpload'

const areaApi = new AreaApi()
const employeesHazardCharacteristicsCardApi = new EmployeesHazardCharacteristicsCardApi()
export default {
  name: 'staff-harm-form',
  components: {
    ImgUpload,
    FormUpload,
  },
  props: {
    FormData: {
      type: Object,
      default: () => {},
    },
    /**
     * @description: 上传传递的参数
     * @param {控制弹窗显示隐藏} visible
     * @return {*}
     */
    formProps: {
      type: Object,
      default: () => {
        return {
          // create 新增 update 编辑 read 详情
          pageType: 'create',
        }
      },
    },
  },
  data() {
    return {
      visible: true,
      loading: false,
      formData: {},
      rules: {
        postName: [{ required: true, message: '请输入岗位名称', trigger: ['blur', 'change'] }],
        postNum: [{ required: true, message: '请输入岗位编号', trigger: ['blur', 'change'] }],
        jobAssociatedRiskAreasIds: [
          { required: true, message: '请选择工作关联风险区域', trigger: ['blur', 'change'] },
        ],
        riskLevel: [{ required: true, message: '请选择风险等级', trigger: ['blur', 'change'] }],
        warningSignsIds: [
          { required: true, message: '请选择警示标志', trigger: ['blur', 'change'] },
        ],
        warningSignPicture: [
          { required: true, message: '请上传警示标志图标，最多5张', trigger: ['blur', 'change'] },
        ],
        dangerousHarmfulFactors: [
          { required: true, message: '请输入危险有害因素', trigger: ['blur', 'change'] },
        ],
        riskControlMeasures: [
          { required: true, message: '请输入应急管控措施', trigger: ['blur', 'change'] },
        ],
        emergencyMeasures: [
          { required: true, message: '请输入应急处置措施', trigger: ['blur', 'change'] },
        ],
        emergencyTelephone: [
          { required: true, message: '请输入应急电话', trigger: ['blur', 'change'] },
        ],
      },
      contractList: [],
      userList: [],
      areaList: [],
      markList: [],
      resultList: [
        {
          code: 0,
          displayName: '重大风险',
        },
        {
          code: 1,
          displayName: '较大风险',
        },
        {
          code: 2,
          displayName: '一般风险',
        },
        {
          code: 3,
          displayName: '低风险',
        },
      ],
    }
  },
  created() {
    utils.getDataCategory(
      ['DoublePreventionManagement.DataCategory.WarningMark'],
      ['markList'],
      this
    )
    // 获取区域列表
    this.getAreaList()
  },
  watch: {
    FormData: {
      handler(newVal, oldVal) {
        this.formData = newVal
        this.$nextTick(() => {
          this.$refs.form.clearValidate()
        })
      },
      immediate: true,
    },
  },
  methods: {
    // 区域选择切换
    areaChange(val) {
      const areaTargetList = []
      let areaTargetStr
      if (val && val.length > 0) {
        _.forEach(this.areaList, (item) => {
          if (val.includes(item.id)) {
            areaTargetList.push(item.riskLevelName)
          }
        })

        if (areaTargetList && areaTargetList.length > 0) {
          areaTargetStr = areaTargetList.join(',')
        }
        if (areaTargetStr.indexOf('重大风险') > -1) {
          this.formData.riskLevel = 0
          return
        }
        if (areaTargetStr.indexOf('较大风险') > -1) {
          this.formData.riskLevel = 1
          return
        }
        if (areaTargetStr.indexOf('一般风险') > -1) {
          this.formData.riskLevel = 2
          return
        }
        if (areaTargetStr.indexOf('低风险') > -1) {
          this.formData.riskLevel = 3
        }
      } else {
        this.formData.riskLevel = undefined
      }
    },
    // 获取区域列表
    async getAreaList() {
      const [err, res] = await areaApi.getList({
        skipCount: 0,
        maxResultCount: 999,
      })
      if (!err) {
        this.areaList = res.items || []
      }
    },
    // 表单提交
    async submitForm() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          this.loading = true
          this.formData.jobAssociatedRiskAreas = this.formData.jobAssociatedRiskAreasIds.join(',')
          this.formData.warningSigns = this.formData.warningSignsIds.join(',')
          this.formData.jobAssociatedRiskAreaStr = _.map(this.$refs.areaSelect.selected, (item) => {
            return item.currentLabel
          }).join(',')
          if (this.formProps.pageType === 'create') {
            const [err, res] = await employeesHazardCharacteristicsCardApi.create({
              body: this.formData,
            })
            if (!err) {
              this.$emit('refreshList')
              this.$message({
                showClose: true,
                message: '新增成功',
                type: 'success',
              })
            }
            this.loading = false
          } else {
            const [err, res] = await employeesHazardCharacteristicsCardApi.update(
              this.formData.id,
              {
                body: this.formData,
              }
            )
            if (!err) {
              this.$emit('refreshList')
              this.$message({
                showClose: true,
                message: '编辑成功',
                type: 'success',
              })
            }
            this.loading = false
          }
        }
      })
    },
    // 关闭弹窗
    closeDialog() {
      this.$emit('cancel')
    },
  },
}
</script>

<style scoped lang="scss">
.custom-height {
  height: calc(100% - 95px);
}

.detail-height {
  height: calc(100% - 50px);
}
</style>
